export default {
    getHeaderFields: state => state.headerFields,
    getAdditionalTableConfig: state => state.additionalTableConfig,
    getRowActions: state => state.rowActions,
}
